import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

// import step1Reducers from '/step1/reducers'
import tipoCadastroReducer from "./tipoCadastro/reduces";
import navegationStepsReducer from "./navegationSteps/reduces";
import dadosIniciaisPFReducer from "./dadosIniciaisPF/reduces";
import dadosIniciaisPJReducer from "./dadosIniciaisPJ/reduces";
import enderecoReducer from "./endereco/reduces";
import dadosComplementaresReducer from "./dadosComplementares/reduces";
import maisDetalhesReducer from "./maisDetalhes/reduces";
import declaracaoEspecificaReducer from "./declaracaoEspecifica/reduces";
import documentosAnexosReducer from "./documentosAnexos/reduces";
import associadoPJReducer from "./associadoPJReducer/reduces";
import resumoReducer from "./resumo/reduces";
import conclusaoReducer from "./conclusao/reduces";
import confirmacaoEmailReducer from "./confirmacaoEmail/reduces";
import confirmacaoEmailAlteracaoReducer from "./confirmacaoEmailAlteracao/reduces";
import dadosBancarioReducer from "./dadosBancarios/reduces";
import formularioReducer from "./kyc/reducers";
import uploadDocumentosReducer from "./uploadDocumentos/reduces";
import ddiReducer from "./ddi/reduces";
import rendaPatrimonioReducer from "./rendaPatrimonio/reduces";
import cotacaoReducer from "./cotacao/reduces";
import renovacaoDocumentosReducer from "./renovacaoDocumentos/reduces";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// Separar -----------------------------
import { combineReducers } from "redux";

const defaultState = {
  state: (state = {}) => state,
};

const persistConfig = {
  key: "root",
  storage,
  // blacklist: ['declaracaoEspecificaReducer']
};

const rootReducers = combineReducers({
  defaultState,
  tipoCadastroReducer,
  navegationStepsReducer,
  dadosIniciaisPFReducer,
  dadosIniciaisPJReducer,
  enderecoReducer,
  dadosComplementaresReducer,
  maisDetalhesReducer,
  declaracaoEspecificaReducer,
  documentosAnexosReducer,
  associadoPJReducer,
  resumoReducer,
  conclusaoReducer,
  confirmacaoEmailReducer,
  confirmacaoEmailAlteracaoReducer,
  dadosBancarioReducer,
  formularioReducer,
  uploadDocumentosReducer,
  ddiReducer,
  rendaPatrimonioReducer,
  cotacaoReducer,
  renovacaoDocumentosReducer
});
//--------------------------------------

const middlewares = [thunk];

const persistedReducer = persistReducer(persistConfig, rootReducers);
const createStoreWithMiddleware = composeWithDevTools(
  applyMiddleware(...middlewares)
)(createStore);

export const store = createStoreWithMiddleware(persistedReducer);
export const persistor = persistStore(store);
